<template>
   <div id="echarts">
   </div>
</template>

<script>
export default {
   data(){
    return {
        myChart:'',
    }
   },
   created(){  
   },
   methods:{
    init(list){
        this.myChart = this.$echarts.init(document.getElementById('echarts'));
        let option = {
            // tooltip: {
            //     show:true,
            // },
            legend: {
                top: 'bottom'
            },
            title:{
                text:'汇总',
            },
            toolbox: {
                show: true,
                feature: {
                mark: { show: true },
                // dataView: { show: true, readOnly: false },
                // restore: { show: true },
                // saveAsImage: { show: true }
                }
            },
            series: [
                {
                name: '饼图',
                type: 'pie',
                radius: [50, 100],
                center: ['50%', '50%'],
                // roseType: 'area',
                itemStyle: {
                    borderRadius: 8
                },
                data: list
                }
            ]
            };
         
           
        this.myChart.setOption(option);
       }
   }
}
</script>

<style scoped lang="scss">
 #echarts{
    height: 500px;
    // width: 400px;
    // border: 1px solid #ccc;
 }

</style>